import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostAdvertise = (srcState, videoState, type) => {
    const navigate = useNavigate()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const request = () => {
        fetchRequest("POST", `/admin/advertise-timer`, {
            "src": type === "image" ? srcState : videoState,
            "type": type === "image" ? "image" : "video"
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                navigate("/ad-timer")
                break
            case 400:
                if (fetchResult?.data?.error_code === "src") setAlert("첨부파일을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [request]
}

export default usePostAdvertise